import { motion } from "framer-motion";

const DriveStats = ({ usedMB = 0, totalGB = 0, percentage = 0 }) => {
  const displayUsedValue = usedMB > 1024
    ? (usedMB / 1024).toFixed(1)
    : usedMB.toFixed(1);
  const displayUnit = usedMB > 1024 ? "GB" : "MB";

  return (
    <div className="bg-indigo-200/60 rounded-xl flex flex-col gap-1.5 px-3 py-3 shadow-md shadow-indigo-400 transition-all duration-300">
      <div className="flex items-start justify-between">
        <div className="flex flex-col flex-1">
          <span className="text-[10px] md:text-[11px] text-black tracking-tight">Total used</span>
          <div className="flex items-baseline leading-none">
            <span className={`text-xl md:text-2xl font-black tracking-tight ${percentage > 90 ? 'text-rose-600' : 'text-slate-900'}`}>
              {displayUsedValue} {displayUnit}
            </span>
            <span className="text-[10px] md:text-[12px] font-bold text-black ml-1">/ {totalGB} GB</span>
          </div>
        </div>
      </div>

      <div className="flex flex-col gap-1">
        <div className="flex justify-between items-end">
          <span className={`text-[11px] text-black  ${percentage > 90 ? 'text-rose-600' : 'text-slate-600'}`}>
            {percentage}% used
          </span>
        </div>
        <div className="w-full bg-slate-100 rounded-full h-3 overflow-hidden border border-slate-200/50">
          <motion.div
            initial={{ width: 0 }}
            animate={{ width: `${percentage}%` }}
            transition={{ duration: 1.5, ease: "circOut" }}
            className={`h-full rounded-none relative transition-colors duration-500 ${percentage > 90 ? 'bg-rose-600' : 'bg-amber-500'}`}
          >
            <div className="absolute inset-0 bg-white/10 opacity-50" />
          </motion.div>
        </div>


      </div>
    </div>
  );
};

export default DriveStats;
